import { FC, SyntheticEvent, useCallback } from 'react';
import { $Locale } from '@lemon8/web-app-shared/atom';
import { useAtomValue } from 'jotai';
import { Article } from '@lemon8/web-app-shared/article';
import { $IsMobileUser } from '~/utils/is-mobile-user';
import { ClickPosition } from '~/utils/click-position';
import { useScopedAtomValue } from '@lemon8/web-app-shared/ssr';
import { PostDetailModalAtoms } from '../../atoms';
import { useActiveToArticle } from '~/utils/active/use-active-to-article';

import './style.scss';

export const ArticleContent: FC = () => {
  const article = useScopedAtomValue(PostDetailModalAtoms.$CurrentArticle);
  const activeToArticle = useActiveToArticle(article);
  const { content, articleRegion } = article;
  const { region } = useAtomValue($Locale);

  const isMobileUser = useAtomValue($IsMobileUser);

  const buildHref = useCallback(
    (path: string) => {
      return `${path.split('?')[0]}?region=${articleRegion || region}`;
    },
    [articleRegion, region],
  );

  const handleEntityWordClick = useCallback(
    (e: SyntheticEvent, payload: { id: string }) => {
      const { id } = payload;

      window.Tea('wap_click', {
        current_position: ClickPosition.main_content_entity_word,
        is_cta: 1,
        page_click_id: id,
      });

      if (isMobileUser) {
        e.preventDefault();
        activeToArticle(ClickPosition.main_content_entity_word, id);
      }
    },
    [isMobileUser, activeToArticle],
  );

  const handleHashtagClick = useCallback(
    (e: SyntheticEvent, payload: { id: string }) => {
      const { id } = payload;

      window.Tea('wap_click', {
        current_position: ClickPosition.main_hashtag,
        is_cta: 1,
        page_click_id: id,
      });

      if (isMobileUser) {
        e.preventDefault();
        activeToArticle(ClickPosition.main_hashtag, id);
      }
    },
    [isMobileUser, activeToArticle],
  );

  const handleLinkClick = useCallback((e: SyntheticEvent) => {
    window.Tea('wap_click', {
      current_position: ClickPosition.main_inner_link,
      is_cta: 1,
    });
  }, []);

  const handleMentionedUserClick = useCallback(
    (e: SyntheticEvent, payload: { id: string }) => {
      const { id } = payload;

      window.Tea('wap_click', {
        current_position: ClickPosition.main_content_mentioned_user,
        is_cta: 1,
        page_click_id: id,
      });

      if (isMobileUser) {
        e.preventDefault();
        activeToArticle(ClickPosition.main_content_mentioned_user, id);
      }
    },
    [isMobileUser, activeToArticle],
  );

  const handlePoiClick = useCallback(
    (e: SyntheticEvent, payload: { id: string }) => {
      const { id } = payload;

      window.Tea('wap_click', {
        current_position: ClickPosition.main_content_poi,
        is_cta: 1,
        page_click_id: id,
      });

      if (isMobileUser) {
        e.preventDefault();
        activeToArticle(ClickPosition.main_content_poi, id);
      }
    },
    [isMobileUser, activeToArticle],
  );

  return (
    <div className="article-content-v2">
      <Article
        buildHref={buildHref}
        content={content}
        onEntityWordClick={handleEntityWordClick}
        onHashtagClick={handleHashtagClick}
        onLinkClick={handleLinkClick}
        onMentionedUserClick={handleMentionedUserClick}
        onPoiClick={handlePoiClick}
      />
    </div>
  );
};
